import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataDictionaryViewReferencesAsyncSlice } from './get';

export const coreDataDictionaryViewReferencesReducers = combineReducers({
	get: getCoreDataDictionaryViewReferencesAsyncSlice.asyncReducers
});

export const coreDataDictionaryViewReferencesWatchers = combineAllWatchers([
	getCoreDataDictionaryViewReferencesAsyncSlice.asyncWatchers
]);
